<template>
  <div
    class="mode-switcher"
    :class="{ 'is-outside': isOutside }"
    @click="switchMode"
  >
    <ul class="toggle-switch">
      <li v-for="mode in modes" :key="mode">
        <input :id="mode" :value="mode" type="radio">
        <label :for="mode" type="radio" :class="activeMode === mode ? 'mode-label active' : 'mode-label'">
          {{ labels['mode-' + mode] }}
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS } from '@/settings'

export default {
  data: function () {
    return {
      modes: ['annually', 'monthly', 'one-off']
    }
  },
  computed: mapState({
    activeMode: state => state.donation.mode,
    labels: state => LABELS[state.language],
    isOutside: state => state.form === 'light-external'
  }),
  methods: {
    switchMode (e) {
      const value = e.target.value
      if (value) this.$store.dispatch('changeMode', value)
    }
  }
}
</script>

<style scoped>
  .mode-switcher {
    margin-bottom: 10px;
  }
  .mode-switcher .toggle-switch {
    display: flex;
    width: 100%;
    height: 35px;
    list-style: none;
    padding: 0;
    margin: 0;
    color: #ABBCC1;
    border: 4px solid #EFF2F3;
  }

  .mode-switcher .toggle-switch li {
    width: 100%;
    height: 100%;
  }

  .mode-switcher .toggle-switch li label {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-family: CoFo Sans;
    font-size: 14px;
    font-weight: 900;
    line-height: 14px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    cursor: pointer;
    background: none;
    transition: .3s cubic-bezier(0,0,0,1);
  }

  .mode-switcher .toggle-switch input[type="radio"] {
    display: none;
  }

  .mode-switcher .toggle-switch li label.active {
    background: #2D2D2D;
    color: #fff;
  }

  .mode-switcher.is-outside .toggle-switch {
    margin-bottom: 4px;
    border: 1px solid #d1d1d1;
    border-radius: 3px;
  }

  .mode-switcher.is-outside li label {
    font-family: inherit;
    font-size: 10px;
    color: rgba(0, 0, 0, 0.75);
    background-color: #fff;
  }

  .mode-switcher.is-outside li label.active {
    background: #ef4e23;
    color: #fff;
  }
</style>
